// Cetvel sabitleri — geometry.js'ten PX_PER_MM yeniden ihraç (tek kaynak).
export { PX_PER_MM } from './geometry';
export const RULER_TICK_LABEL = 9; // px font
